import './styles.scss'
import React from 'react'
import { Collapse } from 'reactstrap'

import UserCard from 'components/UserCard'
import { getStaticImage } from 'utils/statics'
import { MnemonicsBadge } from 'components/mnemonics'

const PoolFoldersItem = (props) => {
  const {
    id, name, color, users = [], size, isActive, tabs, powerUser, unassignMe, assignToMyself,
    selectUser, selectList, handleProps, pendingMsgCount
  } = props

  return (
    <div ref={handleProps.innerRef} className='pool-folders-item' {...handleProps.draggableProps}>
      <div className='pool-folders-item__header'>
        <figure {...handleProps.dragHandleProps} className='pool-folders-item__icon pool-folders-item__icon--drag'>
          <img src={getStaticImage('/icons/orange-brand/icon-drag-dark.svg')} alt='drag drop' />
        </figure>
        <button className='pool-folders-item__header-folder-btn'>
          <i
            className='fa fa-cog'
            aria-hidden='true'
            style={{
              color: color || '#333333'
            }}
          ></i>
          <i
            className='fa fa-folder-o'
            aria-hidden='true'
            style={{
              color: color || '#333333'
            }}
          ></i>
        </button>
        <div
          className={`
          pool-folders-item__header-content
          ${size ? 'pool-folders-item__header-content--hover' : ''}
        `}
          onClick={() => size ? selectList(id) : null}
        >
          <p
            className='pool-folders-item__name text-ellipsis'
            title={name}
          >
            {name}
          </p>
          {
            pendingMsgCount > 0 ? (
              <MnemonicsBadge
                location='userCard'
                value={pendingMsgCount}
              />
            ) : <span />
          }
          <div className='pool-folders-item__mnemonics' title={size || 0}>
            <span>{getSize(size)}</span>
          </div>
          {size ? (
            <figure className='pool-folders-item__icon'>
              <img src={getStaticImage('/icons/orange-brand/icon-arrow-down-gray.svg')} alt='Down arrow' />
            </figure>
          ) : null}
        </div>
      </div>
      <Collapse
        isOpen={size > 0 ? isActive : false}
        className='pool-folders-item__content'
      >
        {users.map((user, index) => (
          <UserCard
            key={index}
            user={user}
            isActive={tabs.activeUser === user.id}
            unassignMe={unassignMe}
            assignToMyself={assignToMyself}
            onClick={selectUser}
            operatorCanAssignACardToItself={!user.assignedTo.includes(powerUser._id)}
            listId={id}
            isShowRemove
          />
        ))}
      </Collapse>
    </div>
  )
}

function getSize(num) {
  if (!num) return 0
  if (num > 99) return `+${num}`

  return num
}

export default PoolFoldersItem
